import React from 'react';
import styled from 'styled-components';

import { IconProps } from '@ant-design/compatible/es/icon';
import Icon from '@ant-design/icons';
import ArrowRightOutlinedIcon from '@icons/sankey/arrow-right-outlined.svg';

interface IFoldButtonProps extends IconProps {
  fold?: boolean;
}

const FoldButtonWrapper = styled(Icon)<IFoldButtonProps>`
  && {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    height: 28px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    transform: ${(props) => (props.fold ? 'none' : 'rotate(180deg)')};
    transition: transform 0.3s ease;
    border-radius: 2px;
    cursor: pointer;

    &:hover {
      color: #0046ff;
      background-color: #f2f6ff;
    }
  }
`;

const FoldButton: React.FC<IFoldButtonProps> = ({ fold = false, ...rest }) => {
  return <FoldButtonWrapper component={ArrowRightOutlinedIcon} fold={fold} {...rest} />;
};

export default FoldButton;
